import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { findIndex, find } from 'lodash';
import Box from '@material-ui/core/Box';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Avatar from "@material-ui/core/Avatar";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';

import { parse, parseISO , getHours } from 'date-fns';

import { scrollbarStylesHorizontal } from '../../../../../utils/scrollbar'
import SkyImage from "../SkyImage";
import drop from '../images/drop.png';
import rainfall from '../images/rainfall.png'
import thermometer from '../images/thermometer.png';
import wind from '../images/wind.png';
import irrigation from '../images/irrigationn.png';
import irrigationOff from '../images/irrigation_off.png';

const useStyles = makeStyles((theme) => ({
    scrollBar: {
        transform: 'translateZ(0)',
        ...scrollbarStylesHorizontal,
    },
    tile: {
        '& .MuiListItem-root': {
            padding: 0,
        },
        '& .MuiBox-root': {
            width: '100%',
        },
        minWidth: 130,
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        padding: 0,
    },
    titleBar: {
        background:
            'linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)',
    },
    image: {
        height: 24,
        marginRight: 2
    },
    small: {
        width: theme.spacing(3),
        height: theme.spacing(3),
    },
}));

const flexContainer = {
    padding: 5,
    minWidth: 'fit-content',
    marginBottom: 10,
};

const spraying_description = {
    1: 'Good for spraying',
    2: 'Not ideal condition for spraying',
    3: "Don't do spraying"
}

const spraying_color = {
    1: 'green',
    2: 'yellow',
    3: "red"
}

export default function HourlyForecast({ data, forecastDayDetail, sprayingData }) {
    const classes = useStyles();
    const [dataHourly, setDataHourly] = React.useState(null);

    React.useEffect(() => {
        const dataH = data.filter(o => o.ref_time.substring(0, 10) === forecastDayDetail.substring(0, 10));

        setDataHourly(dataH)      
    }, [forecastDayDetail])


    const find_spraying = (date) =>{
        if(sprayingData) {
            let sprayingCopy = sprayingData;

            sprayingCopy['prediction'].forEach(element => {
                element['date'] = element['date'].substring(0, 10)
            });
            
            const index = findIndex(sprayingCopy['prediction'], { 'date': forecastDayDetail.substring(0, 10) })
            if (sprayingData['prediction'][index])                
                return find(sprayingData['prediction'][index]['data'], { 'hour': date });

            return null
        }
    };

    const filterPeriod = (periodo) => {
        return parse(periodo, 'HH', parse(forecastDayDetail.substring(0, 10), 'yyyy-MM-dd', new Date()))
    };

    return (
        <>
            {dataHourly && <List style={flexContainer} className={classes.scrollBar}>
                {dataHourly
                    .map((hour, index) => {
                        const spraying = find_spraying(hour.ref_time);

                        return (
                            <Card key={index} style={{ margin: 10 }}>
                                <CardContent>
                                    <List key={`${dataHourly.fecha} ${hour.periodo}`} className={classes.tile}>
                                        <ListItem>
                                            <Box display="flex" justifyContent="center">
                                                <Typography>{getHours(parseISO(hour.ref_time))}:00 </Typography>
                                            </Box>
                                            <Box display="flex" justifyContent="center" m={0.5}>
                                                <SkyImage skyState={hour.detailed_status} date={filterPeriod('01')} />
                                            </Box>
                                            <Tooltip title='Temperatura' aria-label='Temperatura'>
                                                <Box display="flex" justifyContent="center" p={1}>
                                                    <img src={thermometer} alt='thermometer' className={classes.image} />
                                                    {` ${Math.floor(hour.temp.temp)}°`}
                                                </Box>
                                            </Tooltip>
                                            <Tooltip title='Probabilidad de precipitación' aria-label='Probabilidad de precipitación'>
                                                <Box display="flex" justifyContent="center" p={1}>
                                                    <img src={drop} alt='drop' className={classes.image} />
                                                    {` ${Math.floor(hour.precipitation_probability*100)}%`}
                                                </Box>
                                            </Tooltip>
                                            {/* <Tooltip title='Precipitacion' aria-label='Precipitacion'>
                                                <Box display="flex" justifyContent="center" p={1}>
                                                    <img src={rainfall} alt='rainfall' className={classes.image} />
                                                    {` ${'ND'}mm`}
                                                </Box>
                                            </Tooltip> */}
                                            <Tooltip title='Viento' aria-label='Viento'>
                                                <Box display="flex" justifyContent="center" p={1}>
                                                    <img src={wind} alt='wind' className={classes.image} />
                                                    {` ${Math.floor(hour.wnd.speed*(18/5))}km/h`}
                                                </Box>
                                            </Tooltip>
                                            {spraying && <Tooltip title={spraying_description[spraying?.spraying.value]} aria-label='pulverizacion'>
                                                <Box display="flex" justifyContent="center" p={1}>

                                                    {spraying && <Avatar aria-label="recipe"
                                                        style={{ backgroundColor: spraying_color[spraying?.spraying.value] }}
                                                        src={spraying?.spraying.value > 3 ? irrigationOff : irrigation}>

                                                    </Avatar>}
                                                </Box>
                                            </Tooltip>}
                                        </ListItem>
                                    </List>
                                </CardContent>
                            </Card>)

                    })}
            </List>}

        </>
    );
}
